import { useEffect, useRef, useState } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { CommonService } from "../../../../services/CommonService";
import { FeatureService } from "../../../../services/FeatureService";

export const useFeaturesAdmin = (changeAlert: ChangeAlertCallbackType, onOpenUpdateFeatures) => {
    const [type, setType] = useState("");
    const [title, setTitle] = useState("");
    const [active, setActive] = useState(true);
    const [disabled, setDisabled] = useState(true);
    const [loading, setLoading] = useState(false);
    const [listCustomers, setListCustomers] = useState([]);
    const [tabActive, setTabActive] = useState("featureList");
    const [tabs] = useState([
        {name: "featureList", title: "Customer Features" },
        // {name: "featureBlackList", title: "BlackList Features" },
      ]);
    
    const commonService = useRef<CommonService>();
    const featureService = useRef<FeatureService>();

    const init = async () => {
        setType('')
        setTitle('')
        setActive(false)
        setDisabled(true)
    }
    
    const onSelectFile = async (t, e) => {
        let csv = e.target.files[0];
        if(csv.type !== "text/csv"){
          changeAlert(true, 'error', "Error: El tipo de archivo permitido es CSV");
        } else {
            if(t === 'add'){
                setType('featureAssign')                
                setTitle('Agregar beneficio')
            } else {
                setType('featureRemove')                
                setTitle('Remover beneficio')
            }
            let reader = new FileReader();
          
            if(csv){
                reader.readAsDataURL(csv);
                reader.onload = ((binding) => {
                    return async () => {
                        setLoading(true);
                        let parts = reader.result.toString().split(',')[1];
                        let props = {
                            uuid: 'uuid'
                        }
                        const response = await commonService.current.csvToJson(parts, props);
                        if(response?.data?.response === 'OK'){
                            await setListCustomers(response.data.content)
                            setLoading(false);
                            onOpenUpdateFeatures()
                        } else {
                            setLoading(false);
                            changeAlert(true, 'error', response.data.message);
                        }
                    }}
                )(this);
            }
        }
    }

    const updateFeature = async (data) => {
        setLoading(true);        
        const response = await featureService.current[type](data);
        if(response['data'].response === 'OK' && response['data'].result['saved']){
            setLoading(false);
            changeAlert(true, 'success', 'El beneficio fue actualizado con éxito');
        } else {
            setLoading(false);
            changeAlert(true, 'error', response['data'].message || 'El beneficio no pudo ser actualizado');
        }
    };

    const changeTab = (tab: string) => {
        setTabActive(tab);
    };

    useEffect(() => {
        commonService.current = new CommonService(changeAlert)
        featureService.current = new FeatureService(changeAlert)
        init()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return { loading, active, disabled, title, listCustomers, tabs, tabActive, changeTab, onSelectFile, updateFeature }

}
